import { NgModule, Inject, PLATFORM_ID, Optional } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthErrorInterceptor } from './core/interceptors/auth-error.interceptor';
// Firebase imports will be handled by browser-specific modules
import { environment } from './environments/environments';
import { StoresService } from './shared/services/stores.service';
import { DataAccessService } from './shared/services/data-access.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material/autocomplete';
import { Overlay } from '@angular/cdk/overlay';
import { AuthService } from './features/services/auth/auth.service';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { localStorageSync } from 'ngrx-store-localstorage';
import { shopReducer } from './shared/ngrxState/shop.reducer';
import { FbReducer } from './shared/ngrxState/Reducers/fb.reducer';
import { editingTextReducer } from './shared/ngrxState/Reducers/editingTexte.reducer';
import { carouselReducer } from './shared/ngrxState/Reducers/carousel.reducer';
import { textWithButtonsReducer } from './shared/ngrxState/Reducers/text-with-buttons.reducer'

import { mediaReducer} from './shared/ngrxState/Reducers/media.reducer';
import { facebookButtonsReducer } from './shared/ngrxState/Reducers/facebook-buttons.reducer';
import { quickRepliesReducer } from './shared/ngrxState/Reducers/quick-replies.reducer';
import { continueConvReducer } from './shared/ngrxState/Reducers/continue-conv.reducer';
import { responseReducer } from './shared/ngrxState/Reducers/responses.reducer';
import { ResponseStoreModule } from './shared/ngrxState/StoreModule';
import { FacebookLoginProvider, SocialLoginModule, SocialAuthServiceConfig, SocialAuthService } from '@abacritt/angularx-social-login';
import { SharedModule } from './shared/shared.module';
// SocialLoginModule moved to browser module
import { PlatformService } from './shared/services/platform.service';
import { FirebaseSSRConfigService } from './shared/services/firebase-ssr-config.service';
import { isPlatformBrowser } from '@angular/common';
import { NotfoundPageComponent } from './features/pages/notfound-page/notfound-page.component';
import { CommonModule } from '@angular/common';

export function localStorageSyncReducer(reducer: any) {
  return localStorageSync({ 
    keys: ['shop'], 
    rehydrate: true,
    checkStorageAvailability: true
  })(reducer);
}

// Browser-only modules
const browserModules = [];

@NgModule({
  declarations: [
    AppComponent,
    NotfoundPageComponent,
    
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    RouterModule,
    SharedModule ,
    HttpClientModule,
    MatDialogModule,
    StoreModule.forRoot(
      { shop: shopReducer,
        Fb: FbReducer,
        editingText : editingTextReducer,
        carousel: carouselReducer,
        button_text: textWithButtonsReducer,
        facebook_buttons: facebookButtonsReducer,
        media: mediaReducer,
        quickReplies: quickRepliesReducer,
        continueConv: continueConvReducer,
        responses: responseReducer
       
       },
      { metaReducers: [localStorageSyncReducer] }
    ),
    // Browser-only modules
    ...browserModules,
    ResponseStoreModule,
  ],
  providers: [
    TranslateModule, 
    StoresService, 
    DataAccessService, 
    MatSnackBar, 
    AuthService,
    PlatformService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true },
    FirebaseSSRConfigService,
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useFactory: (overlay: Overlay) => ({
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop-dark',
        scrollStrategy: overlay.scrollStrategies.noop(),
      }),
      deps: [Overlay],
    },
    {
      provide: MAT_SELECT_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => () => overlay.scrollStrategies.close(),
      deps: [Overlay],
    },
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => () => overlay.scrollStrategies.close(),
      deps: [Overlay],
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
